import React from 'react';
import { Icon } from './Icon.js';
export const IconBoltFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polygon", { points: "11 3 9 9 16 9 9 17 11 11 4 11 11 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", fill: "currentColor" })));
};
//# sourceMappingURL=IconBoltFilled.js.map